<template>
    <div>
        <v-row justify="center">
            <v-dialog
            v-model="dialog"
            persistent
            max-width="600px"
            >
                <v-card>
                    <v-toolbar dark flat color="primary">
                        <v-toolbar-title>Follow Up</v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-btn icon dark @click="cancel">
                            <v-icon>mdi-close</v-icon>
                        </v-btn>
                        <!-- <v-toolbar-items>
                            <v-btn dark text @click="close"> Save </v-btn>            
                        </v-toolbar-items> -->
                    </v-toolbar>
                    <v-progress-linear
                        v-show="progressBar"
                        indeterminate
                        color="green"
                        >
                    </v-progress-linear>
                    <v-card-title></v-card-title>
                    <v-card-text>
                        <v-container>
                            <v-form ref="form"
                                v-model="valid"
                                lazy-validation>
                                <v-row>
                                    <v-col
                                    cols="12"
                                    sm="12"                                    
                                    >
                                        <v-text-field
                                        label="From"
                                        v-model="from"
                                        disabled
                                        required
                                        >
                                        </v-text-field>
                                    </v-col>                                    
                                </v-row>
                                <v-row>
                                    <v-col
                                    cols="12"
                                    sm="12"                                    
                                    >
                                        <v-text-field
                                        label="To"
                                        v-model="to"
                                        disabled
                                        required
                                        >
                                        </v-text-field>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col
                                    cols="12"
                                    sm="12"                                    
                                    >
                                        <v-text-field
                                        label="Subject"
                                        :rules="subjectRules"
                                        v-model="subject"
                                        required
                                        >
                                        </v-text-field>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col
                                    cols="12"
                                    sm="12"                                    
                                    >
                                        <v-textarea
                                        outlined
                                        v-model="message"
                                        counter
                                        label="Message" 
                                        :rules="MessageRules" 
                                        rows="8"
                                        row-height="30"                                      
                                        ></v-textarea>
                                    </v-col>
                                </v-row>
                            </v-form>
                        </v-container>
                    </v-card-text>
                    <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        color="info"                        
                        @click="cancel()"
                    >
                      <v-icon dark left>mdi-minus-circle</v-icon>Cancel
                    </v-btn>
                    <v-btn
                        color="success"                        
                        @click="send()"
                    >
                      <v-icon left>mdi-send</v-icon>Send
                    </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-row>
    </div>
</template>
<script>
import pairingAPIs from '../../Pairing/pairingAPIs';
export default {
  name: 'followUp',
  props: ['dialog', 'dialogClose', 'from', 'fromName', 'to', 'toName'],
  data: () => ({
    MessageRules: [
    //   v => v.length <= 25 || 'Max 25 characters',
      value => !!value || 'Required.'],
    subjectRules: [value => !!value || 'Required.'],
    valid: true,
    subject: '',
    message: '',
    progressBar: false
  }),
  methods: {
    send() {
      if (this.$refs.form.validate()) {
        this.progressBar = true;
        let formData = {
          fromEmail: this.from,
          fromName: this.fromName,
          toEmail: this.to,
          toName: this.toName,
          subject: this.subject,
          message: this.message
        }
        pairingAPIs.sendFollowUpEmail(formData).then(() => {
          this.progressBar = false
          this.cancel()
        })
      }
    },
    cancel() {
      // this.$refs.form.reset()
      this.subject = ''
      this.message = ''
      this.$refs.form.resetValidation()
      this.dialogClose()
    }
  }
}
</script>



// WEBPACK FOOTER //
// followUp.vue?98306088